import { useEffect, useState } from 'react';
import './App.scss';
// import IdleState from './components/IdleState';
import GameScreen from './components/GameScreen';
import ResultsEffect from './components/ResultsEffect';
import PaylineLabel from './components/PaylineLabel';
import ActionLabel from './components/ActionLabel';
import Background from './components/Background';
import Logo from './components/Logo';

import useSound from 'use-sound';

import { exportStats } from './db';


import click from './assets/audio/BetRivers_SlotMachine_ButtonClick_AAA_20260708.mp3';
import noWinSound from './assets/audio/BetRivers_SlotMachine_NeutralNoWin_AAA_20260708.mp3';
import winSound from './assets/audio/BetRivers_SlotMachine_SmallWin_AAA_20260708.mp3';
import bigWinSound from './assets/audio/BetRivers_SlotMachine_BigWin_AAA_20260708.mp3';
import idleLoop from "./assets/audio/BetRivers_SlotMachine_Attract Music_222 (LOOP).mp3";

const IDLE = 0;
const WAITING = 1;
const PLAYING = 2;
const COMPLETE = 3;

const IDLETIMEOUT = 20000;

function App() {

  const [ gameState, setGameState ] = useState( IDLE );
  const [ result, setResult ] = useState('');
  const [ config, setConfig ] = useState(null);
  
  const [ playClick ] = useSound(click);
  const [ playNoWin ] = useSound(noWinSound);
  const [ playSmallWin ] = useSound(winSound);
  const [ playBigWin ] = useSound(bigWinSound);

  const [ playIdleLoop, { stop, sound } ] = useSound( idleLoop, {loop:true} );


  // load config file.
  useEffect( ()=>{
    fetch('./config.json',{
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    })
      .then((res)=>res.json())
      .then((data)=>{
        console.log('loaded config',data);
        setConfig(data);
      })
      .catch(_=>null);
  },[]);

  useEffect(() => {

    stop();
    if (gameState===IDLE) {
      playIdleLoop();
    }

    if (gameState===COMPLETE) {
      switch (result) {
        case 'bbb':
          playBigWin();
          break;
        case 'vvv':
        case 'hhh':
          playSmallWin();
          break;
        default:
          playNoWin();
      }
    }

    const handleTimeout = () => {
      console.log('timeout');
      setGameState(IDLE);
      setResult('');
    }

    const handleGlobalKeyDown = (event) => {
      clearTimeout(timer);

      if (event.type==='keydown' && event.key==='x') {
        exportStats();
        return;
      }

      console.log('key pressed!',gameState); 
      if (gameState===IDLE) {
        setGameState(WAITING);
        // timer = setTimefout(handleTimeout,10000);
      } else if (gameState===WAITING){
        setGameState(PLAYING);
        playClick();
      } else if (gameState===PLAYING) {
        // do nothing.
      } else if (gameState===COMPLETE) {
        setGameState(WAITING); // or set it back to idle?
        setResult('');
      }
    };

    let timer = setTimeout(handleTimeout,IDLETIMEOUT);
    

    // Attach listener to the window object // debounce by .5sec
    let keytimer = setTimeout( ()=>{ 
      window.addEventListener('keydown', handleGlobalKeyDown);
      window.addEventListener('click', handleGlobalKeyDown);
    }, 500 );

    // Clean up listener when the component unmounts
    return () => {
      window.removeEventListener('keydown', handleGlobalKeyDown);
      window.removeEventListener('click', handleGlobalKeyDown);
      clearTimeout(timer);
      clearTimeout(keytimer);
    };
  }, [gameState]); // Empty dependency array ensures this runs once on mount


  const onSpin = (result) => {
    console.log('result',result);
    setResult(result);
  }
  const onSpinComplete = () => {
    setGameState(COMPLETE);
  }
  
  return (
    <div className="App">
      <Background state={gameState} result={result} />

      <Logo state={gameState} />
      
      <GameScreen isIdle={gameState===IDLE} isPlaying={gameState===PLAYING} onSpin={onSpin} onSpinComplete={onSpinComplete} config={config} />
      
      {/* {gameState===IDLE && <IdleState />} */}

      <PaylineLabel position="left" gameState={gameState} result={result} />
      <PaylineLabel position="right" gameState={gameState} result={result} />

      <div className={`actionLabels ${gameState===IDLE?'idle':''}`}>
        <ActionLabel position={1} gameState={gameState} result={result} />
        <ActionLabel position={2} gameState={gameState} result={result} />
        <ActionLabel position={3} gameState={gameState} result={result} />
      </div>

      {/* <ResultsEffect result="hhh" /> */}
      {gameState===COMPLETE && <ResultsEffect result={result} />}
    </div>
  );
}

export default App;


/* TODO. 
// nice to haves
- timeout results screen to waiting state.
- export daily stats
*/